const variables = {
  pumpHousing: "Pump Housing - Temperature",
  cPbar11: "In Board - Pressure",
  fPbar11: "Out Board - Pressure",
  fiTc23: "FI - Temperature",
  shTc23: "Stuffing Box - Temperature",
  shPbar23: "Stuffing Box - Pressure",
  cwTinC23: "Cooling Water In - Temperature",
  cwToutC23: "Cooling Water Out - Temperature",
  fiTcC32: "In Board - Temperature",
  fiPbarC32: "In Board - Pressure",
  fiTcF32: "Out Board - Temperature",
  fiPbarF32: "Out Board - Pressure",
  cwInTc52: "Cooling Water In - Temperature",
  cwOutTc52: "Cooling Water Out - Temperature",
  oilOutTc52: "Oil Out - Temperature",
  oilInTc52: "Oil In - Temperature",
  shPbar52: "Stuffing Box - Pressure ",
  pBar52: "Vessel Pressure",
  level52: "Vessel Level",
  cBpiTc53b: "In Board - BPI Temperature",
  cBpoPbar53b: "In Board - BPO Pressure",
  cBpoTc53b: "In Board - BPO Temperature",
  cCwInTc53b: "Cooling Water -In Board In - Temperature",
  cCwOutTc53b: "Cooling Water -In Board Out - Temperature",
  cFwInTc53b: "Cooling Water -Out Board In - Temperature",
  cFwOutTc53b: "Cooling Water -Out Board Out  - Temperature",
  cRsPbar53b: "Refilling System -  In Board - Pressure ",
  fBpiTc53b: "Out Board -  BPI Temperature",
  fBpoPbar53b: "Out Board -  BPO Pressure ",
  fBpoTc53b: "Out Board -  BPO Temper",
  fRsPbar53b: "Refilling System - Out Board  - Pressure",
  iaPbar53b: "Instrument Air  - Pressure",
  sysPbar53b: "System - Pressure",
  tankLevel53b: "Tank - Level",
  bpiPbar54: "In Board-BPI - Pressure",
  bpiTc54: "In Board- BPI - Temperature",
  bpoPbar54: "In Board- BPO  - Pressure",
  bpoTc54: "In Board- BPO  - Temperature",
  cwInTc54: "In Board- Cooling Water In - Temperature",
  cwOutTc54: "In Board- Cooling Water Out - Temperature",
  fbpiPbar54: "Out Board-BPI - Pressure",
  fbpiTc54: "Out Board- BPI - Temperature",
  fbpoPbar54: "Out Board- BPO  - Pressure",
  fbpoTc54: "Out Board- BPO  - Temperature",
  fcwInTc54: "Out Board - Cooling Water In - Temperature",
  fcwOutTc54: "Out Board - Cooling Water Out - Temperature",
  fflowLpm54: "Out Board - Barrier Flow",
  flevelL54: "Out Board - Level",
  flowLpm54: "In Board - Barrier Flow",
  fmotorTc54: "Out Board - Motor - Temperature",
  levelL54: "In Board - Level",
  motorTc54: "In Board- Motor - Temperature",
  pumpPressIn: "Suction pressure",
  pumpPressOut: "Discharge pressure",
  pumpRotorSpeed: "Rotor Speed",
  pumpOilLevel: "Oil Level",
  pumpOutflow: "Outflow",
  pumpTempFluid: "Fluid Temperature",
  compressor1StageTemp: "Temperature Stage 1",
  compressor2StageTemp: "Temperature Stage 2",
  compressor3StageTemp: "Temperature Stage 3",
  compressor4StageTemp: "Temperature Stage 4",
  compressor5StageTemp: "Temperature Stage 5",
  compressor6StageTemp: "Temperature Stage 6",
  compressor7StageTemp: "Temperature Stage 7",
  compressor8StageTemp: "Temperature Stage 8",
  compressor9StageTemp: "Temperature Stage 9",
  compressor10StageTemp: "Temperature Stage 10",
  compressor1StagePressure: "Stage Outlet Pressure 1",
  compressor2StagePressure: "Stage Outlet Pressure 2",
  compressor3StagePressure: "Stage Outlet Pressure 3",
  compressor4StagePressure: "Stage Outlet Pressure 4",
  compressor5StagePressure: "Stage Outlet Pressure 5",
  compressor6StagePressure: "Stage Outlet Pressure 6",
  compressor7StagePressure: "Stage Outlet Pressure 7",
  compressor8StagePressure: "Stage Outlet Pressure 8",
  compressor9StagePressure: "Stage Outlet Pressure 9",
  compressor10StagePressure: "Stage Outlet Pressure 10",
  compressorPressureDifference: "Pressure difference across filter",
  compressorTemperatureIn: "Oil inlet temperature",
  compressorDewPoint: "Temperature Dew point",
  compressorOilLevel: "Compressor Oil Level",
  compressorOutflow: "Outflow",
  compressorPressIn: "Input Pressure",
  compressorPressOut: "Outlet Pressure",
  compressorPressureDifference1: "Pressure difference (interstage)",
  compressorNumberOfStages: "Number of stages",
  compressorDriver: "Driver",
  compressorMaxSpeed: "Max Speed",
  compressorPlantAirPressure: "Plant Air Pressure",
  compressorOilPressure: "Oil Pressure",
  compressorLowPinionVibration: "Low Speed Vibration",
  compressorHighPinionVibration: "High Speed Vibration",
  compressorSpeed: "Compressor Speed",
  compressorElectricityConsumption: "Current Demand",
  compressorCoolingWater: "Cooling Water Temperature",
  engineVoltage: "Voltage",
  enginePower: "Power",
  engineEfficiency: "Efficiency",
  engineDriven: "Driven",
  engineFrequency: "Frequency",
  engineSpeed: "Speed",
  enginePowerFactor: "Power Factor",
  gearBoxInputSpeed: "Input Shaft Speed",
  gearBoxOutputSpeed: "Output Shaft Speed",
  gearBoxDriver: "Driver",
  gearBoxDriven: "Driven",
  gearBoxPower: "Power",
  gearServiceFactor: "Service Factor",
  generatorVoltage: "Voltage",
  generatorPower: "Power",
  generatorEfficiency: "Efficiency",
  generatorDriven: "Driven",
  generatorFrequency: "Frequency",
  generatorSpeed: "Speed",
  generatorPowerFactor: "Power Factor",
  ovenOperationPressure: "Operation Pressure",
  ovenOperationTemperature: "Operation Temperature",
  ovenDesignPressure: "Design Pressure",
  ovenDesignTemperature: "Design Temperature",
  ovenHeatAbsorption: "Heat Absorption",
  ovenTubeSkinTemperature: "Tube Skin Temperature",
  ovenOxygenPercentage: "Oxygen Percertange",
  ovenVacuumPressure: "Vacuum Pressure",
  ovenGasInput: "Gas Input",
  ovenOutputTemperature: "Output Temperature",
  ovenCatalystLife: "CatalystLife",
  turbineSpeed: "Speed",
  turbinePower: "Power",
  turbineTemperatureIn: "Inlet Temperature",
  turbinePressureIn: "Inlet Pressure",
  turbineDriven: "Driven",
  turbineNumberOfStages: "Number Of Stages",
  turbineMaxSpeed: "Max Speed",
  turbineExhaustPressure: "Exhaust Pressure",
  turbineTripSpeed: "Trip Speed",
  boilerEconomizerFlow: "Economizer Flow",
  boilerSteam: "Steam",
  boilerAirFlow: "AirFlow",
  boilerFuelFlow: "Fuel Flow",
  boilerExcessOxygen: "Excess Oxygen",
  boilerSteamLevel: "Steam Level",
  boilerSteamPressure: "Steam Pressure",
  boilerSteamTemperature: "Steam Temperature",
  boilerOperationalTemperature: "Operational Temperature",
  boilerDesignTemperature: "Design Temperature",
  boilerDesignPressure: "Design Pressure",
  boilerOperationalPressure: "Operational Pressure",
  boilerSteamCapacity: "Steam Capacity",
  boilerPH: "pH",
  heatExchangerShellTemperatureIn: "Shell inlet Temperature",
  heatExchangerShellTemperatureOut: "Shell outlet Temperature",
  heatExchangerTubesTemperatureIn: "Tubes inlet Temperature",
  heatExchangerTubesTemperatureOut: "Tubes outlet Temperature",
  heatExchangerLogMeanTemperatureDifference: "Log Mean Temperature Difference",
  heatExchangerOperationalShellTemperature:
    "Operational Shell Side Temperature",
  heatExchangerDesignShellTemperature: "Design Shell Side Temperature",
  heatExchangerDesignShellPressure: "Design Shell Side Pressure",
  heatExchangerOperationalShellPressure: "Operational Shell Side Pressure",
  heatExchangerOperationalTubesTemperature:
    "Operational Tubes Side Temperature",
  heatExchangerDesignTubesTemperature: "Design Tubes Side Temperature",
  heatExchangerDesignTubesPressure: "Design Tubes Side Pressure",
  heatExchangerOperationalTubesPressure: "Operational Tubes Side Pressure",
  heatExchangerHeatCapacity: "Heat Capacity",
  reactorOperationalTemperature: "Operational Temperature",
  reactorOperationalPressure: "Operational Pressure",
  reactorDesignTemperature: "Design Temperature",
  reactorDesignPressure: "Design Pressure",
  reactorCatalystLifetime: "Catalyst Lifetime",
  tankLevel: "Level",
  tankPH: "pH",
  tankConductivity: "Conductivity",
  tankConcentration: "Concentration",
  tankCapacity: "Capacity",
  tankVolume: "Volume",
  tankDesignTemperature: "Design Temperature",
  transformerElectricalPower: "Electrical Power",
  transformerPrimaryVoltage: "Primary Voltage",
  transformerSecundaryVoltage: "Secundary Voltage",
  transformerPrimaryCurrent: "Primary Current",
  transformerWindingTemperature: "Winding Temperature",
  transformerImpedance: "Impedance",
  transformerFrequency: "Frequency",
  concentration: "Concentration",
  pH: "pH",
  nitrite: "Nitrite",
  coolingLubricantCode: "Cooling Lubricant Code",
  flameStability: "Stability",
  flameQualityColor: "Color",
  equipmentOperationMode: "Equipment Operation Mode",
  example4Values: "Example 4 Values",
  ventValveMode: "Vent Valve Mode",
  airInletValveMode: "Air Inlet Valve Mode",
  ventingValve: "Venting Valve",
  airInletValve: "Air Inlet Valve",
  highVaporPressure: "High Vapor Pressure"
};
export default variables;
